export default function FilterIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="filter-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (22 / 16) : 22}
      height={height ? height : width ? width * (16 / 22) : 16}
      viewBox="0 0 22 16"
    >
      <g transform="translate(-67 -110)">
        <g
          transform="translate(67 110)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        >
          <rect width="22" height="7" rx="3.5" stroke="none" />
          <rect
            x="0.6"
            y="0.6"
            width="20.8"
            height="5.8"
            rx="2.9"
            fill="none"
          />
        </g>
        <g
          transform="translate(67 119)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
        >
          <rect width="22" height="7" rx="3.5" stroke="none" />
          <rect
            x="0.6"
            y="0.6"
            width="20.8"
            height="5.8"
            rx="2.9"
            fill="none"
          />
        </g>
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(70 112)"
          fill="currentColor"
        />
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(83 121)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
